import { render, staticRenderFns } from "./PrintSessionView2-1.vue?vue&type=template&id=38b6a31a&scoped=true&"
import script from "./PrintSessionView2-1.vue?vue&type=script&lang=js&"
export * from "./PrintSessionView2-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b6a31a",
  null
  
)

export default component.exports